import EarningChart from "./EarningChart";

export default EarningChart